module.exports = __webpack_public_path__ + "static/media/4-01.b62dc62c.png";